export { GiftBoxType, RouteName, WalletProvider, UserStatus, HeroStatus, CosmeticType, CosmeticStatus, NftItemRarity, CosmeticRarity, BoxConfigRefType } from '@wolffun/shared/src/types';
export let WalletStatusResponse;

(function (WalletStatusResponse) {
  WalletStatusResponse["UNKNOWN"] = "UNKNOWN";
  WalletStatusResponse["ACCOUNT_NOT_EXIST"] = "ACCOUNT_NOT_EXIST";
  WalletStatusResponse["ACCOUNT_EXIST"] = "ACCOUNT_EXIST";
})(WalletStatusResponse || (WalletStatusResponse = {}));

export let MenuItem;

(function (MenuItem) {
  MenuItem["REFERRAL_PROGRAM"] = "referral_program";
  MenuItem["INVENTORY"] = "inventory";
  MenuItem["ACCOUNT_SETTINGS"] = "setting";
  MenuItem["HISTORY"] = "history";
  MenuItem["WALLET"] = "wallet";
  MenuItem["IN_GAME"] = "in_game";
  MenuItem["BATTLE_REWARDS"] = "battle_rewards";
  MenuItem["LOGOUT"] = "LOGOUT";
})(MenuItem || (MenuItem = {}));

export let HeroTrophy;

(function (HeroTrophy) {
  HeroTrophy[HeroTrophy["H"] = 1] = "H";
  HeroTrophy[HeroTrophy["G"] = 2] = "G";
  HeroTrophy[HeroTrophy["F"] = 3] = "F";
  HeroTrophy[HeroTrophy["E"] = 4] = "E";
  HeroTrophy[HeroTrophy["D"] = 5] = "D";
  HeroTrophy[HeroTrophy["C"] = 6] = "C";
  HeroTrophy[HeroTrophy["B"] = 7] = "B";
  HeroTrophy[HeroTrophy["A"] = 8] = "A";
  HeroTrophy[HeroTrophy["S"] = 9] = "S";
  HeroTrophy[HeroTrophy["SS"] = 10] = "SS";
})(HeroTrophy || (HeroTrophy = {}));

export let TimeFilterType;

(function (TimeFilterType) {
  TimeFilterType["TIME_ALL"] = "0";
  TimeFilterType["TIME_HOUR_1"] = "1";
  TimeFilterType["TIME_HOUR_24"] = "2";
  TimeFilterType["TIME_DAY_7"] = "3";
  TimeFilterType["TIME_DAY_14"] = "4";
  TimeFilterType["TIME_DAY_30"] = "5";
})(TimeFilterType || (TimeFilterType = {}));

export let RentalState;

(function (RentalState) {
  RentalState[RentalState["OWNER_FOR_RENT"] = 1] = "OWNER_FOR_RENT";
  RentalState[RentalState["OWNER_STOP_FOR_RENT"] = 2] = "OWNER_STOP_FOR_RENT";
  RentalState[RentalState["OWNER_RENTED"] = 3] = "OWNER_RENTED";
  RentalState[RentalState["OWNER_RETURN"] = 4] = "OWNER_RETURN";
  RentalState[RentalState["RENTER_RENTED"] = 5] = "RENTER_RENTED";
  RentalState[RentalState["RENTER_RETURN"] = 6] = "RENTER_RETURN";
})(RentalState || (RentalState = {}));